<template>
  <a-card :bordered="false" title="积分规则" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row style="margin-bottom: 20px;">
      <a-col :span="18">
        <a-input-search v-model="searchQueryParams.productName" placeholder="请输入积分商品名称" style="width: 350px"
                        @search="onSearch"/>
        <a-button type="primary" :disabled="convertType==0" style="margin-left: 10px" @click="onNewPage(0)">
          新建积分商品
        </a-button>
      </a-col>
      <a-col :span="6" style="text-align: right;">兑换结算规则 <a @click="openModel">设置</a></a-col>
    </a-row>
    <custom-page-table
      ref="table"
      :columns="getColumnsList()"
      :queryParams="searchQueryParams"
      :requestPromise="loadPromise"
      :enableSearch="false"
    >
      <span slot="action" slot-scope="rowItem">
        <span v-if="rowItem.record.productSource==0">
          <a @click="onNewPage(rowItem.record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="确认删除此条数据吗?" @confirm="onDelete(rowItem.record.pointsProductId)">
            <a>删除</a>
          </a-popconfirm>
        </span>
        <a v-else @click="onNewPage(rowItem.record)">查看</a>
      </span>
    </custom-page-table>
    <a-modal title="兑换结算规则" :width="700" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 15 }">
        <a-form-model-item label="积分兑换模式" required>
          <a-radio-group v-model="ruleForm.convertType">
            <a-radio :style="radioStyle" :value="0">无成本模式(所有兑换权益由第三方免费提供，禁止新建积分商品)</a-radio>
            <a-radio :style="radioStyle" :value="1">
              部分成本模式(积分+现金，部分积分或现金成本由商户承担，允许新建积分商品)
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 15,offset: 5 }" style="margin-bottom: 0;">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button @click="handleCancel" style="margin-left: 10px;">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'IntegralProList',
  mixins: [],
  components: {},
  data() {
    return {
      searchQueryParams: {
        productName: ''
      },
      loadPromise: params => this.getListPromise(params),
      visible: false,
      ruleForm: {
        convertType: 0
      },
      convertType: 0,
      rules: {
        climbingCycle: [{ required: true, message: '请选择会员等级周期', trigger: 'change' }]
      },
      submitLoading: false,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '40px'
      }
    }
  },
  mounted() {
    this.getProductConvertInfo()
  },
  methods: {
    onSearch() {
      this.$refs.table.refresh(true)
    },
    onNewPage(record) {
      const params = {
        id: record.pointsProductId,
        source: record.productSource
      }
      this.openNewPage('NewIntegralPro', params)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getIntegralApiService().post('admin/points/product/list/page', params)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('params', params)
      this.getHttpServices().getIntegralApiService().post('admin/points/product/convert/rule/save', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.visible = false
        this.$refs.table.refresh(true)
        this.getProductConvertInfo()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    openModel() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    getProductConvertInfo() {
      this.getHttpServices().getIntegralApiService().post('admin/points/product/convert/rule/info').then(res => {
        this.getLogUtils().logWithTag('getProductConvertInfo', res)
        this.ruleForm.convertType = res.convertType
        this.convertType = res.convertType
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onDelete(id) {
      this.getHttpServices().getIntegralApiService().post('admin/points/product/delete', { pointsProductId: id }).then(res => {
        this.$message.success('删除成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumnsList() {
      return [
        {
          title: 'ID',
          dataIndex: 'pointsProductId'
        },
        {
          title: '积分商品名称',
          dataIndex: 'productName'
        },
        {
          title: '所需费用',
          dataIndex: 'points'
        },
        {
          title: '商品类型',
          dataIndex: 'productTypeStr'
        },
        {
          title: '兑换方式',
          dataIndex: 'conventTypeStr'
        },
        {
          title: '商品来源',
          dataIndex: 'productSourceStr'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}
</style>
